import Column from 'components/Column'
import { actions, selectors } from 'data'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import FirstSetup2FA from 'scenes/Account/FirstSetup2FA'
import styled from 'styled-components'

import GeneralSecondFactorInput from '../SecondFactorInput'
import BeneficiarySelect from './BeneficiarySelect'
import Empty from './Empty'

const Wrapper = styled(Column)`
  padding: 0 0 0.5rem 0;
`

const SecondFactorInput = styled(GeneralSecondFactorInput)`
  margin-top: 0;
`

type Props = {
  availableFunds: boolean
  beneficiaryError: React.ReactNode
  beneficiaryMetadata: string
  beneficiaryType: string
  beneficiaryValue: string
  currency: string
  onBeneficiaryMetadataChange: (metadata: string) => void
  onBeneficiaryTypeChange: (type: string) => void
  onBeneficiaryValueChange: (value: string) => void
  onSecondFactorChange: (type: string) => void
  secondFactor: string
}

const Body = ({
  availableFunds,
  beneficiaryError,
  beneficiaryMetadata,
  beneficiaryType,
  beneficiaryValue,
  currency,
  onBeneficiaryMetadataChange,
  onBeneficiaryTypeChange,
  onBeneficiaryValueChange,
  onSecondFactorChange,
  secondFactor
}: Props) => {
  const dispatch = useDispatch()
  const twoFactorStatus = useSelector(selectors.auth.getTwoFactorStatus)
  const has2FASetup = twoFactorStatus && twoFactorStatus.length > 0

  useEffect(() => {
    dispatch(actions.twoFactor.getStatus())
  }, [])

  if (!availableFunds) {
    return <Empty currency={currency} />
  }

  return (
    <Wrapper>
      <BeneficiarySelect
        currency={currency}
        error={beneficiaryError}
        metadata={beneficiaryMetadata}
        onMetadataChange={onBeneficiaryMetadataChange}
        onTypeChange={onBeneficiaryTypeChange}
        onValueChange={onBeneficiaryValueChange}
        type={beneficiaryType}
        value={beneficiaryValue}
      />
      {(beneficiaryType === 'external' || beneficiaryType === 'wallet') &&
        (has2FASetup ? (
          <SecondFactorInput onChange={onSecondFactorChange} value={secondFactor} />
        ) : (
          <FirstSetup2FA dark />
        ))}
    </Wrapper>
  )
}

export default Body
